import { Box } from '@hover/blueprint';
import React, { useEffect } from 'react';

import { ActiveToast } from 'src/shared/components/Toast/components/ActiveToast';
import { PassiveToast } from 'src/shared/components/Toast/components/PassiveToast';

import type { SliceOfToast } from './types';
import { ToastType } from './types';

const TOAST_TIMEOUT = 5000;

const renderToast = (toast: SliceOfToast, toasts: SliceOfToast[]) => {
  switch (toast.type) {
    case ToastType.PASSIVE:
      return <PassiveToast toast={toast} />;
    case ToastType.ACTIVE:
    default:
      return <ActiveToast toast={toast} toasts={toasts} />;
  }
};

const Toast = ({
  toast,
  toasts,
}: {
  toast: SliceOfToast;
  toasts: SliceOfToast[];
}) => {
  const { onPress } = toast;

  // Set up timer to clear toast
  useEffect(() => {
    const timer = setTimeout(() => onPress?.(toast, toasts), TOAST_TIMEOUT);

    return () => clearTimeout(timer);
  }, [toast, onPress, toasts]);

  return (
    <Box alignItems="center" justifyContent="center" width="100%">
      {renderToast(toast, toasts)}
    </Box>
  );
};

export { Toast };
